class InsideLevelReadMore {
  constructor(el) {
    this.text = el.querySelector('[data-readmore-text]');
    this.btn = el.querySelector('[data-readmore-btn]');
    if (!this.text || !this.btn) return;
    this.expanded = false;
    this.collapsedMaxHeight = this.text.clientHeight;
    this.btn.addEventListener('click', this.toggle.bind(this));
    this.checkOverflow();
  }

  checkOverflow() {
    if (this.text.scrollHeight <= this.text.clientHeight + 1) {
      this.btn.style.display = 'none';
    }
  }

  toggle() {
    this.expanded = !this.expanded;
    const target = this.text.scrollHeight;

    if (this.expanded) {
      this.btn.textContent = 'Read Less';
      this.text.style.maxHeight = target + 'px';
      const onEnd = (e) => {
        if (e.propertyName !== 'max-height' || e.target !== this.text) return;
        this.text.style.maxHeight = 'none';
        this.text.removeEventListener('transitionend', onEnd);
      };
      this.text.addEventListener('transitionend', onEnd);
    } else {
      this.text.style.maxHeight = target + 'px';
      // eslint-disable-next-line no-unused-expressions
      this.text.offsetHeight;
      this.text.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.btn.textContent = 'Read More';
      const onEnd = (e) => {
        if (e.propertyName !== 'max-height' || e.target !== this.text) return;
        this.text.style.maxHeight = '';
        this.text.removeEventListener('transitionend', onEnd);
      };
      this.text.addEventListener('transitionend', onEnd);
    }
  }
}

if (!customElements.get('inside-level')) {
  class InsideLevel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.desktopBreakpoint = 1024;
      this.desktopVisibleCards = 3;
      this.resizeFrame = null;
      this.handleResize = this.handleResize.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.onResize);
      this.initReadMore();
      document.fonts.ready.then(() => this.equalizeCardContent());
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.resizeFrame) {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
      }
      this.destroy();
    }

    onResize() {
      if (this.resizeFrame) return;
      this.resizeFrame = requestAnimationFrame(() => {
        this.resizeFrame = null;
        this.handleResize();
      });
    }

    get swiperContainer() {
      return this.querySelector('.inside-level__slider');
    }

    get paginationEl() {
      return this.querySelector('.swiper-pagination');
    }

    get prevButtonEl() {
      return this.querySelector('.swiper-button-prev');
    }

    get nextButtonEl() {
      return this.querySelector('.swiper-button-next');
    }

    get slides() {
      return this.querySelectorAll('.swiper-slide');
    }

    initReadMore() {
      this.querySelectorAll('[data-readmore]').forEach((el) => new InsideLevelReadMore(el));
    }

    equalizeCardContent() {
      const titles = [...this.querySelectorAll('.level-card__title')];
      const subtitles = [...this.querySelectorAll('.level-card__subtitle')];

      titles.forEach((el) => (el.style.minHeight = ''));
      subtitles.forEach((el) => (el.style.minHeight = ''));

      if (this.swiper) return;

      const maxTitleH = titles.reduce((max, el) => Math.max(max, el.offsetHeight), 0);
      if (maxTitleH > 0) titles.forEach((el) => (el.style.minHeight = maxTitleH + 'px'));

      const maxSubtitleH = subtitles.reduce((max, el) => Math.max(max, el.offsetHeight), 0);
      if (maxSubtitleH > 0) subtitles.forEach((el) => (el.style.minHeight = maxSubtitleH + 'px'));
    }

    getConfig() {
      return {
        slidesPerView: 1,
        slidesOffsetAfter: 12,
        slidesOffsetBefore: 12,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        pagination: {
          el: this.paginationEl,
          type: 'fraction',
        },
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: this.nextButtonEl,
          prevEl: this.prevButtonEl,
        },
        breakpoints: {
          768: {
            slidesPerView: 1.6,
            slidesPerGroup: 1,
            spaceBetween: 20,
            slidesOffsetAfter: 20,
            slidesOffsetBefore: 20,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 12,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= this.desktopBreakpoint;
      const slideCount = this.slides.length;
      const shouldUseSliderDesktop = slideCount > this.desktopVisibleCards;

      if (isDesktop) {
        if (shouldUseSliderDesktop) {
          if (!this.swiper) {
            this.init();
          }
        } else {
          if (this.swiper) {
            this.destroy();
          }
          this.equalizeCardContent();
        }
      } else {
        if (!this.swiper) {
          this.init();
        }
      }
    }

    init() {
      if (typeof Swiper === 'undefined') return;
      if (this.swiperContainer) {
        this.classList.add('slider-active');
        this.swiper = new Swiper(this.swiperContainer, this.getConfig());

        if (this.swiper.pagination) {
          this.swiper.pagination.update();
        }

        if (this.swiper.navigation) {
          this.swiper.navigation.update();
        }
      }
    }

    destroy() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.classList.remove('slider-active');
    }
  }

  customElements.define('inside-level', InsideLevel);
}
